import React from 'react';
import 'tslib';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { Badge } from './Badge.esm.js';

var AlertBadge = function (_a) {
    var count = _a.count, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId;
    return (React.createElement(Badge, { dataMetrics: dataMetrics, dataTestId: dataTestId || "badge-".concat(testIdGen(count.toString())), appearance: "red" }, count));
};

export { AlertBadge };
//# sourceMappingURL=AlertBadge.esm.js.map
